import React from 'react';
import SchoolYearSummaryDisplay from '../features/summary/SchoolYearSummaryDisplay';
import PageHeader from '../components/PageHeader';

const SchoolYearSummaryPage: React.FC<{ refresh: boolean }> = ({ refresh }) => {
    return (
        <div className="page">
            <PageHeader title="Podsumowanie roczne" subtitle="Przychody, wydatki i salda w kolejnych latach szkolnych" />
            <SchoolYearSummaryDisplay refresh={refresh} />
        </div>
    );
};

export default SchoolYearSummaryPage;
